import { IconButton, ShortcutProvider } from "@itk/mui-components";
import { Dialog, DialogActions, DialogContent, DialogTitle, Typography, Stack, useTheme } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { GenericDialogProps } from "./generic-dialog-types";
import { genericTranslationsK } from "src/translation-hooks/generic-translations";

export const GenericDialog = ({ onClose, headerTitle, contentTitle, children, renderDialogActions, isLoading = false, dialogProps, dialogContentProps }: GenericDialogProps) => {
  const theme = useTheme();

  return (
    <ShortcutProvider>
      <Dialog open onClose={isLoading ? undefined : onClose} disableEscapeKeyDown={isLoading} maxWidth="sm" fullWidth {...dialogProps}>
        <DialogTitle
          sx={{
            bgcolor: theme.palette.customColors.grey,
            py: 1,
            color: theme.palette.customColors.darkGrey,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        >
          {headerTitle ? <Typography fontWeight={theme.typography.fontWeightBold}>{headerTitle}</Typography> : <InfoOutlinedIcon fontSize="small" />}
          <IconButton k={genericTranslationsK.close} onClick={onClose} disabled={isLoading}>
            <CloseOutlinedIcon sx={{ color: theme.palette.customColors.darkGrey }} />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers {...dialogContentProps}>
          <Stack color={theme.palette.customColors.darkGrey}>
            {contentTitle && (
              <Typography variant="body1" fontWeight={theme.typography.fontWeightBold} gutterBottom>
                {contentTitle}
              </Typography>
            )}
            {children}
          </Stack>
        </DialogContent>

        {renderDialogActions && <DialogActions style={{ gap: 2 }}>{renderDialogActions}</DialogActions>}
      </Dialog>
    </ShortcutProvider>
  );
};
